module.exports = __webpack_public_path__ + "img/storage_icon.3ac7ef71.png";